import { FieldError } from "../FieldError";
import { useIsMobile } from "../hooks";
import { Radio } from "../Radio";
import { Typo } from "../Typo";

type RadioProps = {
  label: string;
  value: string | null;
  options: { label: string; value: string; disabled?: boolean }[];
  onChange: (value: string) => void;
  error?: string;
  disabled?: boolean;
};

export const RadioGroup = ({
  label,
  value,
  options,
  onChange,
  error,
}: RadioProps) => {
  const isMobile = useIsMobile();

  return (
    <div className="flex flex-col gap-2">
      <Typo element="h6" type={isMobile ? "labelSM" : "labelMD"} textColor="">
        {label}
      </Typo>
      <div className="flex flex-col gap-3">
        {options.map((option) => (
          <Radio
            key={option.value}
            label={option.label}
            value={option.value}
            checked={value === option.value}
            onChange={onChange}
            error={error}
            disabled={option.disabled}
          />
        ))}
      </div>
      {error && <FieldError text={error} />}
    </div>
  );
};
